import { useEffect } from "react";
import { Navigate, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actions } from "./redux/AuthRedux";

export function Logout() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.logout());
    document.location.reload();
  }, [dispatch]);

  return (
    <Routes>
      <Navigate to="/auth/login" />
    </Routes>
  );
}
